:host {
  display: block;
  max-width: 100%;
}

gz-info-box {
  padding: calc(var(--spacer) * 2) 0 calc(var(--spacer) * 3) 0;
}

.has-bullet {
  position: relative;
  font-family: inherit;

  &:before {
    content: '';
    max-width: 5px;
    max-height: 5px;
    color: inherit;
    min-width: 5px;
    min-height: 5px;
    background-color: var(--body-text-arrows-400);
    transform: translateY(-2px);
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }
}
